import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import "./App.css";
import React, { useEffect, useState  } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

import Entrar from './entrar';
import Cadastrar from './cadastrar';
import ForgotPassword from './forgot-password';
import ResetPassword from './reset-password';
import Home from './Home';
import VideoPublico from './VideoPublico';
import ProtectedRoute from './ProtectedRoute';
import DeletarDados from './DeletarDados';
import PoliticaPrivacidade from './PoliticaPrivacidade';

function App() {


  
 return (
    <BrowserRouter>
        <Routes>
          {/* Rota PÚBLICA para visualização de vídeo (Flutter/compartilhamento) */}
          <Route path="/video/:id" element={<VideoPublico />} />

          <Route path="/" element={<ProtectedRoute><Home /></ProtectedRoute>} />
          <Route path="/entrar" element={<Entrar />} />
          <Route path="/cadastrar" element={<Cadastrar />} />
          <Route path="/register" element={<Navigate to="/cadastrar" replace />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/solicitar-exclusao" element={<DeletarDados />} />
          <Route path="/politica-de-privacidade" element={<PoliticaPrivacidade />} />

        </Routes>
      </BrowserRouter>

  )

}
export default App;